/* IPERTECH 2026 - SEARCH DRAWER v4 (build 2026-05-15T17:29:56Z) - solo prodotti + anti-doppia-UI Dawn */
(function(){
  'use strict';
  var W = window, D = document;
  var RECENT_KEY = 'ipt_search_recent';
  var RECENT_MAX = 6;
  var DEBOUNCE_MS = 250;

  function ready(fn){ D.readyState !== 'loading' ? fn() : D.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var root = D.querySelector('[data-ipt-srch]');
    if(!root){ console.warn('[ipt-srch] root non trovato'); return; }
    init(root);
  });

  function formatMoney(val){
    if(val === null || val === undefined || val === '') return '';
    var n = parseFloat(val);
    if(isNaN(n)) return '';
    var amount = n > 1000 && Number.isInteger(n) ? n / 100 : n;
    try { return new Intl.NumberFormat('it-IT', {style:'currency', currency:'EUR'}).format(amount); }
    catch(e){ return '€' + amount.toFixed(2).replace('.', ','); }
  }

  function esc(s){
    if(s == null) return '';
    return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function shopifyImgUrl(src, size){
    if(!src) return '';
    size = size || '128x';
    return src.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + '$1$2');
  }

  function readRecent(){
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch(e){ return []; }
  }
  function writeRecent(arr){
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, RECENT_MAX))); }
    catch(e){}
  }
  function addRecent(q){
    if(!q || q.length < 2) return;
    var arr = readRecent();
    var idx = arr.indexOf(q);
    if(idx !== -1) arr.splice(idx, 1);
    arr.unshift(q);
    writeRecent(arr);
  }

  /* ===== Anti-doppia-UI: sopprime la search NATIVA di Dawn ===== */
  function isOutsideIpt(el){
    if(!el || !el.closest) return true;
    return !el.closest('[data-ipt-srch]');
  }

  function suppressNativeSearch(){
    /* 1. <details open> con input search nativi (non i nostri) */
    D.querySelectorAll('details[open]').forEach(function(d){
      if(!isOutsideIpt(d)) return;
      if(d.querySelector('input[name="q"]:not([data-ipt-srch-input]), input[type="search"]:not([data-ipt-srch-input])')){
        d.removeAttribute('open');
      }
    });
    /* 2. <predictive-search> e .predictive-search */
    D.querySelectorAll('predictive-search, .predictive-search, .predictive-search__results, #predictive-search-results, [id^="predictive-search"]').forEach(function(el){
      if(!isOutsideIpt(el)) return;
      el.setAttribute('hidden', '');
      try { el.style.display = 'none'; } catch(ex){}
    });
    /* 3. .search-modal e simili */
    D.querySelectorAll('.search-modal, .search-modal__content, .search-modal__form, details-modal, [id*="SearchModal"], [class*="search-modal"]').forEach(function(el){
      if(!isOutsideIpt(el)) return;
      el.setAttribute('hidden', '');
      el.classList.remove('is-open', 'active', 'show', 'open');
      try { el.style.display = 'none'; } catch(ex){}
    });
    /* 4. Blur input nativi */
    D.querySelectorAll('input[name="q"]:not([data-ipt-srch-input]), input[type="search"]:not([data-ipt-srch-input])').forEach(function(inp){
      if(!isOutsideIpt(inp)) return;
      try { inp.blur(); } catch(ex){}
    });
  }

  /* ===== Auto-attach data-ipt-search-open ai trigger Dawn comuni ===== */
  function autoAttachTriggers(){
    var sel = [
      '.header__icon--search',
      'summary.header__icon--search',
      'summary[aria-label*="search" i]',
      'summary[aria-label*="cerca" i]',
      'button[aria-label*="search" i]:not([data-ipt-srch-close]):not([data-ipt-srch-clear])',
      'button[aria-label*="cerca" i]:not([data-ipt-srch-close]):not([data-ipt-srch-clear])',
      'a[aria-label*="search" i]',
      'a[aria-label*="cerca" i]',
      '[data-search-modal-toggle]',
      'a[href$="/search"]:not([data-ipt-skip])'
    ].join(', ');
    D.querySelectorAll(sel).forEach(function(el){
      if(!isOutsideIpt(el)) return;
      if(el.hasAttribute('data-ipt-srch-close')) return;
      if(el.hasAttribute('data-ipt-srch-clear')) return;
      if(!el.hasAttribute('data-ipt-search-open')){
        el.setAttribute('data-ipt-search-open', '');
      }
    });
  }

  function init(root){
    var ovl        = D.querySelector('[data-ipt-srch-ovl]');
    var input      = root.querySelector('[data-ipt-srch-input]');
    var form       = root.querySelector('[data-ipt-srch-form]');
    var closeBtn   = root.querySelector('[data-ipt-srch-close]');
    var clearBtn   = root.querySelector('[data-ipt-srch-clear]');
    var initialEl  = root.querySelector('[data-ipt-srch-initial]');
    var resultsEl  = root.querySelector('[data-ipt-srch-results]');
    var loadingEl  = root.querySelector('[data-ipt-srch-loading]');
    var noResEl    = root.querySelector('[data-ipt-srch-noresults]');
    var productsEl = root.querySelector('[data-ipt-srch-products]');
    var groupProd  = root.querySelector('[data-ipt-srch-group-products]');
    var viewAll    = root.querySelector('[data-ipt-srch-view-all]');
    var recentWrap = root.querySelector('[data-ipt-srch-recent-wrap]');
    var recentEl   = root.querySelector('[data-ipt-srch-recent]');
    var recentClear= root.querySelector('[data-ipt-srch-recent-clear]');

    var limit         = parseInt(root.getAttribute('data-srch-limit') || '8', 10);
    var lastQuery     = '';
    var debounceTimer = null;
    var abortCtrl     = null;

    function open(){
      suppressNativeSearch();
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      if(ovl) ovl.classList.add('is-open');
      D.body.classList.add('ipt-srch-open');
      renderRecent();
      setTimeout(function(){ if(input) input.focus(); }, 80);
      /* Suppressione persistente per ~700ms (copre animazioni Dawn) */
      var ticks = 0;
      var iv = setInterval(function(){
        suppressNativeSearch();
        if(++ticks >= 14) clearInterval(iv);
      }, 50);
    }

    function close(){
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      if(ovl) ovl.classList.remove('is-open');
      D.body.classList.remove('ipt-srch-open');
    }

    /* ===== Click trigger globali — CAPTURE PHASE + preventDefault ===== */
    D.addEventListener('click', function(e){
      var t = e.target.closest('[data-ipt-search-open]');
      if(!t) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var pd = t.closest('details');
      if(pd) pd.removeAttribute('open');
      open();
    }, true);

    /* Anche pointerdown/mousedown (Dawn talvolta usa pointer events) */
    ['pointerdown','mousedown','touchstart'].forEach(function(ev){
      D.addEventListener(ev, function(e){
        var t = e.target.closest('[data-ipt-search-open]');
        if(!t) return;
        var pd = t.closest('details');
        if(pd) pd.removeAttribute('open');
      }, true);
    });

    if(closeBtn) closeBtn.addEventListener('click', close);
    if(ovl)      ovl.addEventListener('click', close);
    D.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    if(clearBtn){
      clearBtn.addEventListener('click', function(){
        if(input){ input.value = ''; input.focus(); }
        clearBtn.style.display = 'none';
        lastQuery = '';
        showInitial();
      });
    }

    if(form){
      form.addEventListener('submit', function(){
        var q = input && input.value && input.value.trim();
        if(q) addRecent(q);
      });
    }

    if(input){
      input.addEventListener('input', function(){
        var q = input.value.trim();
        if(clearBtn) clearBtn.style.display = q ? '' : 'none';
        if(debounceTimer) clearTimeout(debounceTimer);
        if(!q || q.length < 2){ lastQuery = ''; showInitial(); return; }
        debounceTimer = setTimeout(function(){ search(q); }, DEBOUNCE_MS);
      });
    }

    function showInitial(){
      if(initialEl) initialEl.style.display = '';
      if(resultsEl) resultsEl.style.display = 'none';
      if(loadingEl) loadingEl.style.display = 'none';
      if(noResEl)   noResEl.style.display   = 'none';
      renderRecent();
    }
    function showLoading(){
      if(initialEl) initialEl.style.display = 'none';
      if(resultsEl) resultsEl.style.display = 'none';
      if(loadingEl) loadingEl.style.display = '';
      if(noResEl)   noResEl.style.display   = 'none';
    }
    function showResults(){
      if(initialEl) initialEl.style.display = 'none';
      if(resultsEl) resultsEl.style.display = '';
      if(loadingEl) loadingEl.style.display = 'none';
      if(noResEl)   noResEl.style.display   = 'none';
    }
    function showNoResults(){
      if(initialEl) initialEl.style.display = 'none';
      if(resultsEl) resultsEl.style.display = 'none';
      if(loadingEl) loadingEl.style.display = 'none';
      if(noResEl)   noResEl.style.display   = '';
    }

    function search(q){
      if(q === lastQuery) return;
      lastQuery = q;
      showLoading();
      if(abortCtrl && abortCtrl.abort){ try{ abortCtrl.abort(); } catch(ex){} }
      abortCtrl = W.AbortController ? new AbortController() : null;

      /* Params minimi — Shopify usa default per fields/unavailable_products.
         NB: passare un valore non valido in resources[options][fields] (es. "sku")
         fa fallire l'intera chiamata con HTTP 422 → "Nessun risultato". */
      var params = new URLSearchParams();
      params.set('q', q);
      params.append('resources[type]', 'product');
      params.set('resources[limit]', String(limit));

      var opts = { headers: { 'Accept': 'application/json' } };
      if(abortCtrl) opts.signal = abortCtrl.signal;

      var url = '/search/suggest.json?' + params.toString();
      console.log('[ipt-srch] fetch:', url);
      fetch(url, opts)
        .then(function(r){ console.log('[ipt-srch] status:', r.status); return r.json(); })
        .then(function(data){
          var n = ((data && data.resources && data.resources.results) || {}).products;
          console.log('[ipt-srch] products:', n ? n.length : 0);
          renderResults(data, q);
        })
        .catch(function(err){
          if(err && err.name === 'AbortError') return;
          console.warn('[ipt-srch] error:', err);
          showNoResults();
        });
    }

    function renderResults(data, q){
      var products = ((data && data.resources && data.resources.results) || {}).products || [];
      if(!products.length){ showNoResults(); return; }
      if(productsEl) productsEl.innerHTML = products.map(renderProduct).join('');
      if(groupProd)  groupProd.style.display = '';
      if(viewAll)    viewAll.href = '/search?type=product&q=' + encodeURIComponent(q);
      showResults();
    }

    function renderProduct(p){
      var img     = p.image || (p.featured_image && p.featured_image.url) || '';
      img         = shopifyImgUrl(img, '128x');
      var price   = p.price !== undefined ? p.price : (p.price_min !== undefined ? p.price_min : '');
      var compare = p.compare_at_price !== undefined ? p.compare_at_price
                    : (p.compare_at_price_min !== undefined ? p.compare_at_price_min : null);
      var hasSale = compare && parseFloat(compare) > parseFloat(price);
      var vendor  = p.vendor || '';
      return ''
        + '<li class="ipt-srch__prod">'
        +   '<a class="ipt-srch__prod-l" href="' + esc(p.url) + '">'
        +     (img
              ? '<img class="ipt-srch__prod-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="64" height="64">'
              : '<div class="ipt-srch__prod-img"></div>')
        +     '<div class="ipt-srch__prod-info">'
        +       (vendor ? '<p class="ipt-srch__prod-v">' + esc(vendor) + '</p>' : '')
        +       '<p class="ipt-srch__prod-t">' + esc(p.title) + '</p>'
        +       '<div class="ipt-srch__prod-pr">'
        +         '<span class="ipt-srch__prod-now">' + formatMoney(price) + '</span>'
        +         (hasSale ? '<span class="ipt-srch__prod-was">' + formatMoney(compare) + '</span>' : '')
        +       '</div>'
        +     '</div>'
        +   '</a>'
        + '</li>';
    }

    function renderRecent(){
      var arr = readRecent();
      if(!recentEl || !recentWrap) return;
      if(!arr.length){ recentWrap.style.display = 'none'; return; }
      recentWrap.style.display = '';
      recentEl.innerHTML = arr.map(function(q){
        return '<button type="button" class="ipt-srch__recent-i" data-q="' + esc(q) + '">'
          + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8v4l3 2M21 12a9 9 0 1 1-9-9c2.5 0 4.8 1 6.5 2.7" stroke="currentColor" fill="none" stroke-width="1.6" stroke-linecap="round"/></svg>'
          + '<span>' + esc(q) + '</span>'
          + '</button>';
      }).join('');
      recentEl.querySelectorAll('[data-q]').forEach(function(b){
        b.addEventListener('click', function(){
          var q = b.getAttribute('data-q');
          if(input){ input.value = q; }
          if(clearBtn) clearBtn.style.display = '';
          lastQuery = '';
          search(q);
        });
      });
    }

    if(recentClear){
      recentClear.addEventListener('click', function(){ writeRecent([]); renderRecent(); });
    }

    /* ===== Boot: auto-attach + suppress + observer permanente ===== */
    autoAttachTriggers();
    suppressNativeSearch();

    if(W.MutationObserver){
      new MutationObserver(function(mutations){
        var needsAttach = false, needsSuppress = false;
        for(var i = 0; i < mutations.length; i++){
          var m = mutations[i];
          if(m.type === 'childList' && m.addedNodes && m.addedNodes.length){
            needsAttach = true;
            if(D.body.classList.contains('ipt-srch-open')) needsSuppress = true;
          }
          if(m.type === 'attributes' && m.attributeName === 'open' &&
             m.target.tagName === 'DETAILS' && D.body.classList.contains('ipt-srch-open')){
            needsSuppress = true;
          }
        }
        if(needsAttach) autoAttachTriggers();
        if(needsSuppress) suppressNativeSearch();
      }).observe(D.body, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['open']
      });
    }

    W.iptSearch = { open: open, close: close, suppress: suppressNativeSearch, attach: autoAttachTriggers };
    console.log('[ipt-srch] v3 ready — solo prodotti + anti-doppia-UI');
  }
})();